import { ActorTypes } from '@savgroup-front-common/constants';

import { AddressInfoDto } from './AddressInfo';

export interface ActorSummary {
  id: string;
  actorType: ActorTypes;
  actorSubType?: string;
  fullName: string;
  address: AddressInfoDto;
  note: string;
  phone: string;
  floor: string;
  doorCode: string;
  additionalInformation: string;
  mailAddresses: string[];
  websitesUrl: string[];
}

export interface ContractActor {
  id: string;
  sellerId: string;
  uniqueName: string;
  displayName: string;
  externalId: string;
  actorType: ActorTypes;
  address: AddressInfoDto;
  mail: string;
  phone: string;
}

export enum SELF_ONBOARDING_ACTOR_TYPE {
  NONE = 'None',
  PARTNER = 'Partner',
  WORKSHOP = 'Workshop',
  HUB = 'Hub',
}

export enum PARTNER_TYPE {
  WAREHOUSE = 'Warehouse',
  REPAIRER = 'Repairer',
  MANUFACTURER = 'Manufacturer',
  RETAILER = 'Retailer',
}

export enum ACTOR_TYPE {
  WAREHOUSE = 'warehouse',
  REPAIRER = 'repairer',
  MANUFACTURER = 'manufacturer',
  BUSINESS_PARTNER = 'businessPartner',
}

export interface SelfOnboardingActor {
  actorId?: string;
  actorSolutionRuleId?: string;
  siteActorRuleId?: string;
  sellerId: string;
  actorType: SELF_ONBOARDING_ACTOR_TYPE;
  partnerType?: PARTNER_TYPE;
  uniqueName: string;
  displayName: string;
  externalId?: string;
  address: AddressInfoDto;
  mail: string;
  phone: string;
  warranties: {
    id: string;
    label: string;
  }[];
  modelTypes: {
    id: string;
    label: string;
  }[];
  brands: {
    id: string;
    label: string;
  }[];
  ownerZipCode: {
    countryCode: string;
    zipCodes: string[];
  };
  reversSellerName: string;
  partnerProcessType: string;
  partnerScenarioType: string;
  openToPublic: boolean;
}
